import * as yup from 'yup';
export const requiredText = 'Поле является обязательным для заполнения';
export const minText = 'Количество символов в поле должно быть не меньше 3';
export const notValidEmail = 'Не валидный email';

export const adminValidationSchema = yup.object({
  name: yup.string().min(3, minText).required(requiredText),
  surname: yup.string().min(3, minText).required(requiredText),
  email: yup.string().email(notValidEmail).required(requiredText),
  role: yup.mixed().required(requiredText),
  status: yup.mixed().required(requiredText),
  password: yup
    .string()
    .min(
      8,
      'Только буквы латинского алфавита, символы, цифры. Обязательно наличие одной заглавной буквы. Не менее 8 и не более 12 символов'
    )
    .required(requiredText),
  password_reset: yup
    .string()
    .oneOf([yup.ref('password')], 'Пароли не совпадают')
    .required(requiredText),
});

export const adminEditValidationSchema = yup.object({
  name: yup.string().min(3, minText).required(requiredText),
  surname: yup.string().min(3, minText).required(requiredText),
  email: yup.string().email(notValidEmail).required(requiredText),
  role: yup.mixed().required(requiredText),
  status: yup.mixed().required(requiredText),
});
